import type { ActiveCrierSpeech, CrierAnnouncement } from '@/modules/town-news/utils/crier-announcement';

/** Presentation only: a snapshot and its WS event are the same original utterance. */
export class CrierSpeechPresenter {
  private occurrenceId: string | null = null;
  present(speech: ActiveCrierSpeech, now: number, display: (announcement: CrierAnnouncement, remainingMs: number) => boolean): boolean {
    if (speech.occurrenceId === this.occurrenceId) return false;
    const start = Date.parse(speech.atUTC), end = Date.parse(speech.expiresAtUTC);
    if (now < start || now >= end || !display(speech.announcement, Math.min(12000, end - now))) return false;
    this.occurrenceId = speech.occurrenceId;
    return true;
  }
}
